import {
  type ChildMachineConfig,
  AirPriceDropState,
  AirPriceDropActionTypes,
} from "@hopper-b2b/checkout";
import { AirPriceDropGuardTypes } from "./guards";

export const getAirPriceDropMachine = (config: ChildMachineConfig) => {
  return {
    initial: AirPriceDropState.route,
    states: {
      [AirPriceDropState.route]: {
        always: [
          {
            target: AirPriceDropState.addProduct,
            cond: AirPriceDropGuardTypes.hasPriceDropIdAndEnabled,
          },
          {
            target: config.nextState,
          },
        ],
      },
      [AirPriceDropState.addProduct]: {
        always: [
          {
            actions: AirPriceDropActionTypes.addPriceDropProduct,
            target: config.nextState,
          },
        ],
      },
    },
  };
};
